import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
type Refresh = () => void

interface DeleteItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingDeleteItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmDelete: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const deleteItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingDeleteItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmDelete,
  setOpenDeleteModal,
}: DeleteItemReservationParams): Promise<void> => {
  try {
    setLoadingDeleteItem(true)
    setOpenDeleteModal && setOpenDeleteModal(false)
    const response = await itemServices.update_status_item('DELETED', hashItemReserve)
    if (response?.status === 'DELETED') {
      notify('ra.notification.delete_item_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmDelete && setConfirmDelete(false)
      setLoadingDeleteItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmDelete && setConfirmDelete(false)
    setLoadingDeleteItem(false)
    notify('ra.notification.delete_item_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error:any) {
    if(error.response?.data?.detail){
      notify(error.response.data?.detail + '_delete', {
        type: 'error',
      })
    } else {
      notify('ra.notification.delete_item_error', {
        type: 'error',
        messageArgs: { item: nameReserve },
      })
    }
    setNameReserve('')
    setHashItemReserve('')
    setLoadingDeleteItem(false)
    setConfirmDelete && setConfirmDelete(false)
    setOpenDeleteModal && setOpenDeleteModal(false)
  } finally {
    customAwait([refresh])
  }
}
